<template>
  <table class="mailTable" :style="styleObject" v-if="s_showByRow">
    <tr v-for="index in rowCount" :key="index">
      <td class="column" >{{tableData[index*2-2].label}}</td>
      <td >{{tableData[index*2-2].value}}</td>
      <td class="column" >{{tableData[index*2-1] !== undefined ? tableData[index*2-1].label : ''}}</td>
      <td >{{tableData[index*2-1] !== undefined ? tableData[index*2-1].value : ''}}</td>
    </tr>
  </table>
  <table class="mailTable" :style="styleObject" v-else>
    <tr v-for="index in rowCount" :key="index">
      <td class="column" >{{tableData[index-1].label}}</td>
      <td >{{tableData[index-1].value}}</td>
      <td
        class="column"
       
      >{{tableData[rowCount+index-1] !== undefined ? tableData[rowCount+index-1].label : ''}}</td>
      <tdv-if="tableData[rowCount+index-1]">{{tableData[rowCount+index-1] !== undefined ? tableData[rowCount+index-1].value : ''}}</tdv-if=>
    </tr>
  </table>
</template>

<script>
export default {
  data() {
    return {
      styleObject: {},
      s_showByRow: true,
      tableData: []
    };
  },
  props: ["rows", "tableStyle", "titles"],
  watch:{
   rows(a,b){
      this.tableData = [];
    //处理数据
    this.titles.forEach((v,i)=>{
      this.tableData.push({key:v[0],label:v[1]})
    })
    this.tableData.forEach((v,i)=>{
       for (let s in this.rows) {
         if(v.key==s){
          this.tableData[i].value = this.rows[s];
         }
    }
    })
    }
  },
  computed: {
    rowCount: function() {
      return Math.ceil(this.tableData.length / 2);
    }
  },
  created() {
    this.styleObject = this.tableStyle;
    if (this.showByRow !== undefined) {
      this.s_showByRow = this.showByRow;
    }
  },
  mounted() {
    this.tableData = [];
    //处理数据
    this.titles.forEach((v,i)=>{
      this.tableData.push({key:v[0],label:v[1]})
    })
    this.tableData.forEach((v,i)=>{
       for (let s in this.rows) {
         if(v.key==s){
          this.tableData[i].value = this.rows[s];
         }
    }
    })
  }
};
</script>
<style scoped lang='less'>
.mailTable {
  margin-top: 20px;
}
td {
  width: 200px;
  word-break: break-all;
  height: 40px;
  border: 2px solid #08396a;
  background: rgba(5, 43, 79, 0.3);
  text-indent: 7px;
}
.column {
  word-break: break-all;
  background: #375572 !important;
}
/deep/ .el-table__row{
  pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/components/table2.vue